<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <garage-salary-create-or-update v-model="garageSalary" :errors="errors"></garage-salary-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    name="garage-salary"
                    :buttons="buttons"
                    pagination = "server"
                    search
                    :items-provider="provider"
                    ></v-table>
    </b-card>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import GarageSalaryCreateOrUpdate from './components/GarageSalaryCreateOrUpdate.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'


export default {
    components:{
        BCard,
        GarageSalaryCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            loading:false,
            errors:{},
            fields:[
                { name:"Garaj",key:"VehicleInventoryGarage.GarageName",thClass:"w-50"},
                { name:"Geçerlilik Başlangıç Tarihi",key:"Date",thClass:"w-25"},
                { name:"Maaş",key:"SalaryString", thClass:"w-25",sortable:true},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            garageSalary:{
                Id:null,
                VehicleInventoryGarageId:null,
                Salary:null,
                Date:null
            },
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.garageSalary.Id = null
            this.garageSalary.VehicleInventoryGarageId = null
            this.garageSalary.Salary = null
            this.garageSalary.Date = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.garageSalary.Id = item.Id
            this.garageSalary.VehicleInventoryGarageId = item.VehicleInventoryGarage?.Id || null
            this.garageSalary.Salary = item.Salary
            this.garageSalary.Date = moment(item.Date,'DD.MM.YYYY').format('YYYY-MM-DD')
            this.$showModal('create-or-update')
        },
        async createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.GarageSalary.CreateOrUpdate(this.editing,this.garageSalary)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
            .catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        provider(data){
            return EmployeeOperationsApi.GarageSalary.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.VehicleInventoryGarage?.GarageName} garajına ait maaş bilgisini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.GarageSalary.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>